module.exports = __webpack_public_path__ + "media/newstyle/images/whatsapp-ea8e47bec8e352db259c83a732e323da.svg";